// extracted by mini-css-extract-plugin
export default {"container":"AdminConfigHealth_container__zaXEZ"};